// 記事
exports.Articles = App.Views.Base.extend({
  el: '.js-article-area',
  template: null,
  defaultProps: {
    // 記事を取得するAPIのパス
    apiPath: null,
    // 記事一覧のページ番号
    page: 1,
    // 1回で何件読み込むか
    limit: 10,
    // 記事読み込み中か
    isLoading: false,
    // 最後まで読み込み済みか
    loadedLast: false,
    // テンプレート
    template: require('../../../hbs/find_article.hbs')
  },
  initialize: function(options) {
    $('.js-loader', this.$el).show();

    // defaultPropsは固定値としたいのでdeep copyしてからobjectの更新をする
    this.props = $.extend(true, {}, this.defaultProps);
    if (options) {
      _.extend(this.props, options);
    }
    this.template = this.props.template;
  },
  load: function(data) {
    if (this.isLoading || this.loadedLast) {
      return;
    }
    this.isLoading = true;
    var _this = this;
    var loader = $('.js-loader', this.$el);
    if (!data) {
      data = {};
    }
    data.page = this.props.page;
    data.limit = this.props.limit;
    $.ajax({
      type: 'GET',
      headers: {
        'X-MAMARIQ-UUID': App.me.User.uuid
      },
      url: this.props.apiPath,
      data: data
    }).done(function(data) {
      if (data.response.length > 0) {
        $('.js-article-list', _this.$el).append(
          data.response.map(function(value) {
            return _this.template(value);
          })
        );
        _this.props.page++;
      }
      if (data.response.length < _this.props.limit) {
        // limit分取得できない = 最後
        _this.loadedLast = true;
        loader.hide();
      }
    }).fail(function(jqXHR) {
      loader.hide();
      var data = App.parseError(jqXHR);
      if (data && _.has(data.error, 'message')) {
        alert(data.error.message);
        return;
      }
      App.networkErrorAlert();
    }).always(function() {
      _this.isLoading = false;
    });
  }
});



// WEBPACK FOOTER //
// ./webroot/js/sp/views/find-content.js